/**
 * Tiny module-level store used to pass page context (current project,
 * current work item) to the floating `ActiveTimer` widget.
 *
 * Verbatim port of the Next `timer-context.ts`. Pages that know the
 * context call `setTimerContext`; the floating timer reads the most
 * recently set values whenever the start dialog opens and preselects
 * them.
 */

export type TimerPageContext = {
  projectId?: string;
  workItemId?: string;
};

let current: TimerPageContext = {};
const listeners = new Set<() => void>();

export function getTimerContext(): TimerPageContext {
  return current;
}

export function setTimerContext(next: TimerPageContext): void {
  current = { ...next };
  for (const l of listeners) l();
}

export function clearTimerContext(): void {
  current = {};
  for (const l of listeners) l();
}

export function subscribeTimerContext(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
